import { client } from "../client/client";

export const fetchGuarantors = async (
  page,
  limit,
  query,
  fromDate,
  toDate,
  exportType = "json"
) => {
  try {
    let url = `/api/v1/guarantors/allrequestscombined?page=${page}&limit=${limit}&export=${exportType}`;

    if (query) {
      url += `&search=${encodeURIComponent(query)}`;
    }

    if (fromDate) {
      url += `&from=${encodeURIComponent(fromDate)}`;
    }

    if (toDate) {
      url += `&to=${encodeURIComponent(toDate)}`;
    }

    console.log("Final request URL:", url);

    const response = await client.get(url);
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching guarantors:", error);
    throw error?.response?.data || error;
  }
};

// Fetch guarantor summary (totals + top 5 most exposed)
export const fetchGuarantorsSummary = async () => {
  try {
    const response = await client.get("/api/v1/guarantors/allrequests/summary");
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchGuarantorLoans = async (publicId, page, limit) => {
  try {
    const response = await client.get(
      `/api/v1/guarantors/guarantors/${publicId}/loans?page=${page}&limit=${limit}`
    );
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportGuarantorExposureAsCSV = async ({
  from,
  to,
  search,
  page,
  limit,
}) => {
  try {
    const params = {
      export: "csv",
    };

    if (from) params.from = from;
    if (to) params.to = to;
    if (search) params.search = search;
    if (page) params.page = page;
    if (limit) params.limit = limit;

    const response = await client.get(
      "/api/v1/guarantors/allrequestscombined",
      {
        params,
        responseType: "blob",
      }
    );

    const contentDisposition = response.headers["content-disposition"];
    const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
    const fileName = fileNameMatch
      ? fileNameMatch[1]
      : "list_of_guarantors.csv";

    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "text/csv;charset=utf-8;" })
    );

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Guarantor CSV export failed:", error);
    throw error?.response?.data || error;
  }
};
